import React, { useEffect, useState, useRef } from "react";
import parse from "html-react-parser";
import { DateTime } from "luxon";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import {
  DialogActions,
  IconButton,
  InputAdornment,
  TextField,
} from "@material-ui/core";
import { OverlayPanel } from "primereact/overlaypanel";
import { Card } from "react-bootstrap";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import { CalendarMonth, Search, Today } from "@mui/icons-material";
import DialogLayout from "../../../../partials/content/DialogLayout";
import SearchFiscalYear from "../../setup/finance/searchFiscalYear";
import SearchFiscalPeriod from "../../setup/finance/searchFiscalPeriod";
import { formatDate } from "../../../../utils/utils";
import { getGlAccountBalance } from "../../../../services/finance/financeReportService";
import SearchGlAccount from "../../setup/finance/searchGlAccount";
import NumberFormat from "react-number-format";
import Illustration from "../../../../partials/content/Illustration";
import CustomDataTable from "../../../../partials/content/CustomDataTable";

function GlAccountBalance(props) {
  const {
    currentFiscalYear,
    currentFiscalPeriod,
    reload,
    companyProfile,
  } = useGlobalData();
  const selectParamOp = useRef(null);
  const [glAccount, setGlAccount] = useState({ ID: 0, accountName: "" });
  const [searchByFiscalYear, setSearchByFiscalYear] = useState(false);
  const [openSearchFiscalYear, setOpenSearchFiscalYear] = useState(false);
  const [openSearchFiscalPeriod, setOpenSearchFiscalPeriod] = useState(false);
  const [openSearchGlAccount, setOpenSearchGlAccount] = useState(false);
  const [plusdbInd, setPlusdbInd] = useState("D");
  const [fiscalYear, setFiscalYear] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [fiscalPeriod, setFiscalPeriod] = useState(
    currentFiscalPeriod.ID > 0
      ? currentFiscalPeriod
      : {
          ID: 0,
          fiscalYearID: 0,
          year: DateTime.now().year,
          month: DateTime.now().month,
          monthName: DateTime.now().toLocaleString({
            month: "long",
          }),
          statusID: 0,
        }
  );
  const [glAccountBalance, setGlAccountBalance] = useState([]);

  useEffect(() => {}, [reload]);
  const GlAccountBalanceDetailColumn = [
    {
      header: "Note",
      field: "note",
      body: (rowData) => parse(rowData.note),
      sortable: true,
      filter: true,
    },
    {
      header: "Date",
      field: "date",
      body: (rowData) => formatDate(rowData.date),
      sortable: true,
      filter: true,
    },
    {
      header: "Debit/Credit",
      field: "dbInd",
      body: (rowData) => (
        <React.Fragment>
          {rowData.dbInd === "D"
            ? "Debit"
            : rowData.dbInd === "C"
            ? "Credit"
            : ""}
        </React.Fragment>
      ),
      sortable: true,
      filter: true,
    },
    {
      header: "Currency",
      field: "currencyCode",
      body: null,
      sortable: true,
      filter: true,
      hidden: true,
    },
    {
      header: "Amount",
      field: "amount",
      body: (rowData) => (
        <NumberFormat
          value={rowData.amount}
          displayType={"text"}
          thousandSeparator={true}
          decimalScale={2}
          renderText={(value) => (
            <div
              className={`float-right ${
                plusdbInd === "D" && rowData.dbInd === "D"
                  ? "text-success"
                  : plusdbInd === "D" && rowData.dbInd === "C"
                  ? "text-danger"
                  : plusdbInd === "C" && rowData.dbInd === "D"
                  ? "text-danger"
                  : plusdbInd === "C" && rowData.dbInd === "C"
                  ? "text-success"
                  : ""
              }`}
            >
              {rowData.currencyCode} {value}
            </div>
          )}
        />
      ),
    },
  ];
  return (
    <React.Fragment>
      <OverlayPanel
        ref={selectParamOp}
        showCloseIcon
        dismissable={false}
        id="overlay_panel"
        style={{ width: "450px" }}
        className="overlaypanel-demo"
      >
        <div className="row mb-3">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <Card>
              <Card.Header>
                <i className="fas fa-filter"></i>
                <span>
                  <strong>Filter Selection</strong>
                </span>
              </Card.Header>
              <Card.Body>
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    {searchByFiscalYear === true ? (
                      <TextField
                        id="fiscalYear"
                        label="Fiscal Year"
                        value={
                          fiscalYear.startMonthName +
                          " " +
                          fiscalYear.year +
                          " - " +
                          fiscalYear.endMonthName +
                          " " +
                          fiscalYear.yearTo
                        }
                        style={{ width: "100%" }}
                        variant="outlined"
                        size="small"
                        margin="normal"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <BootstrapTooltip title="Search">
                                <IconButton
                                  type="button"
                                  aria-label="Search"
                                  onClick={() => {
                                    setOpenSearchFiscalYear(true);
                                  }}
                                  edge="end"
                                >
                                  <Search />
                                </IconButton>
                              </BootstrapTooltip>
                              <BootstrapTooltip title="Search By Fiscal Period">
                                <IconButton
                                  type="button"
                                  aria-label="SearchBy"
                                  onClick={() => {
                                    setFiscalYear({
                                      ID: 0,
                                      year: 0,
                                      yearTo: 0,
                                      startMonth: 0,
                                      startMonthName: "",
                                      endMonth: 0,
                                      endMonthName: "",
                                    });
                                    setSearchByFiscalYear(false);
                                    if (currentFiscalPeriod.ID > 0) {
                                      setFiscalPeriod(currentFiscalPeriod);
                                    }
                                  }}
                                  edge="end"
                                >
                                  <Today />
                                </IconButton>
                              </BootstrapTooltip>
                            </InputAdornment>
                          ),
                          readOnly: true,
                        }}
                      />
                    ) : (
                      <TextField
                        id="fiscalPeriod"
                        label="Fiscal Period"
                        value={fiscalPeriod.monthName + " " + fiscalPeriod.year}
                        style={{ width: "100%" }}
                        variant="outlined"
                        size="small"
                        margin="normal"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <BootstrapTooltip title="Search">
                                <IconButton
                                  type="button"
                                  aria-label="Search"
                                  onClick={() => {
                                    setOpenSearchFiscalPeriod(true);
                                  }}
                                  edge="end"
                                >
                                  <Search />
                                </IconButton>
                              </BootstrapTooltip>
                              <BootstrapTooltip title="Search By Fiscal Year">
                                <IconButton
                                  type="button"
                                  aria-label="SearchBy"
                                  onClick={() => {
                                    setFiscalPeriod({
                                      ID: 0,
                                      fiscalYearID: 0,
                                      year: DateTime.now().year,
                                      month: DateTime.now().month,
                                      monthName: DateTime.now().toLocaleString({
                                        month: "long",
                                      }),
                                      statusID: 0,
                                    });
                                    setSearchByFiscalYear(true);
                                    if (currentFiscalYear.ID > 0) {
                                      setFiscalYear(currentFiscalYear);
                                    }
                                  }}
                                  edge="end"
                                >
                                  <CalendarMonth />
                                </IconButton>
                              </BootstrapTooltip>
                            </InputAdornment>
                          ),
                          readOnly: true,
                        }}
                      />
                    )}
                    <TextField
                      id="glAccount"
                      label="General Ledger Account"
                      value={glAccount.accountName}
                      style={{ width: "100%" }}
                      variant="outlined"
                      size="small"
                      margin="normal"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <BootstrapTooltip title="Search">
                              <IconButton
                                type="button"
                                aria-label="Search"
                                onClick={() => {
                                  setOpenSearchGlAccount(true);
                                }}
                                edge="end"
                              >
                                <Search />
                              </IconButton>
                            </BootstrapTooltip>
                          </InputAdornment>
                        ),
                        readOnly: true,
                      }}
                    />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <button
              type="button"
              className="btn btn-success btn-md btn-pill btn-bold float-right"
              onClick={() => {
                if (fiscalYear.ID > 0 && glAccount.ID > 0) {
                  getGlAccountBalanceData(fiscalYear.ID, 0, 0, glAccount.ID);
                } else if (
                  fiscalPeriod.year > 0 &&
                  fiscalPeriod.month > 0 &&
                  glAccount.ID > 0
                ) {
                  getGlAccountBalanceData(
                    0,
                    fiscalPeriod.year,
                    fiscalPeriod.month,
                    glAccount.ID
                  );
                }
              }}
            >
              <i className="fas fa-search"></i>
              Get Account Balance
            </button>
          </div>
        </div>
      </OverlayPanel>
      {glAccountBalance.length ? (
        <React.Fragment>
          <CustomDataTable
            data={glAccountBalance}
            dataDetailName="glAccountBalance"
            dataDetailColumns={GlAccountBalanceDetailColumn}
            dataDetailTitle="Account Balance Items"
            onRefreshData={() => {
              if (fiscalYear.ID > 0 && glAccount.ID > 0) {
                getGlAccountBalanceData(fiscalYear.ID, 0, 0, glAccount.ID);
              } else if (
                fiscalPeriod.year > 0 &&
                fiscalPeriod.month > 0 &&
                glAccount.ID > 0
              ) {
                getGlAccountBalanceData(
                  0,
                  fiscalPeriod.year,
                  fiscalPeriod.month,
                  glAccount.ID
                );
              }
            }}
            buttons={[
              {
                name: "Filter",
                onClick: (e) => {
                  selectParamOp.current.toggle(e);
                },
                icon: "fas fa-search",
                color: "info",
              },
            ]}
            columns={[
              {
                header: "Year",
                field: "year",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Month",
                field: "monthName",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Opening Balance",
                field: "openingBalance",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.openingBalance}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className={`float-right`}>
                        {companyProfile.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
              },
              {
                header: "Ending Balance",
                field: "endingBalance",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.endingBalance}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className={`float-right`}>
                        {companyProfile.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO Payment.png"
            description={`You don't have any General Ledger Account Balance for current data selection!`}
            guidance={`Hint: Try to filter another data selection to get some results`}
            descriptionLeftIcon="fas fa-info-circle kt-font-info"
            size="md"
          ></Illustration>
          <div className="text-center py-3">
            <button
              type="button"
              className="btn btn-info btn-md btn-pill btn-bold mx-1"
              onClick={(e) => {
                selectParamOp.current.toggle(e);
              }}
            >
              <i className="fas fa-search"></i>
              Filter
            </button>
          </div>
        </React.Fragment>
      )}
      <DialogLayout
        open={openSearchFiscalYear}
        title="Search Fiscal Year"
        onCloseDialog={() => {
          setOpenSearchFiscalYear(false);
        }}
        maxWIdth="md"
      >
        <SearchFiscalYear
          onSelectFiscalYear={(fiscalYear) => {
            setFiscalYear({
              ID: fiscalYear.ID,
              year: fiscalYear.year,
              yearTo: fiscalYear.yearTo,
              startMonth: fiscalYear.startMonth,
              startMonthName: fiscalYear.startMonthName,
              endMonth: fiscalYear.endMonth,
              endMonthName: fiscalYear.endMonthName,
            });
            setFiscalPeriod({
              ID: 0,
              fiscalYearID: 0,
              year: DateTime.now().year,
              month: DateTime.now().month,
              monthName: DateTime.now().toLocaleString({
                month: "long",
              }),
              statusID: 0,
            });
            setOpenSearchFiscalYear(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchFiscalYear(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchFiscalPeriod}
        title="Search Fiscal Period"
        onCloseDialog={() => {
          setOpenSearchFiscalPeriod(false);
        }}
        maxWIdth="md"
      >
        <SearchFiscalPeriod
          onSelectFiscalPeriod={(fiscalPeriod) => {
            setFiscalPeriod({
              ID: fiscalPeriod.ID,
              fiscalYearID: fiscalPeriod.fiscalYearID,
              year: fiscalPeriod.year,
              month: fiscalPeriod.month,
              monthName: fiscalPeriod.monthName,
              statusID: fiscalPeriod.statusID,
            });
            setFiscalYear({
              ID: 0,
              year: 0,
              yearTo: 0,
              startMonth: 0,
              startMonthName: "",
              endMonth: 0,
              endMonthName: "",
            });
            setOpenSearchFiscalPeriod(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchFiscalPeriod(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchGlAccount}
        title="Search GL Account"
        onCloseDialog={() => {
          setOpenSearchGlAccount(false);
        }}
        maxWIdth="md"
      >
        <SearchGlAccount
          accountTypeID={0}
          onSelectGlAccount={(account) => {
            setGlAccount(account);
            setOpenSearchGlAccount(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchGlAccount(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );

  async function getGlAccountBalanceData(
    fiscalYearID = 0,
    fiscalYear = 0,
    fiscalPeriod = 0,
    glAccountID = 0
  ) {
    const response = await getGlAccountBalance(
      fiscalYearID,
      fiscalYear,
      fiscalPeriod,
      glAccountID
    );

    const { data } = response.data;
    setGlAccountBalance(data.glAccountBalance);
    setPlusdbInd(data.plusdbInd);
  }
}

export default GlAccountBalance;
